import './styles.scss'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { BillionaireBrews, BillionaireBrewsMobileScreen } from 'Assets/Images'
import MetaTagsComponent from 'Components/MetaTagsComponent'
import { getLocalUserDetails } from 'Utils/LocalStorage_Handler'
import useAnalytics from 'Utils/useAnalytics'
import { SCREEN_EVENTS } from 'Utils/Constants/analyticsEvents'

const BillionaireBrew = () => {
  const { t } = useTranslation()
  const windowSize = window.innerWidth
  const userDetails = getLocalUserDetails()
  const { setScreenLog } = useAnalytics()

  // user-analytics
  useEffect(() => {
    setScreenLog(SCREEN_EVENTS.BILLIONAIRES_BREW_SCREEN)
  }, [])

  return (
    <>
      <MetaTagsComponent title={t('BILLIONAIRE_BREWS_TITLE')} description={t('BILLIONAIRE_BREWS_DESCRIPTION')} keywords={t('BILLIONAIRE_BREWS_KEYWORDS')} url="https://coffeeweb.com/billionaireBrew" h1Content={t('BILLIONAIRE_BREWS_H1_CONTENT')} />

      <div className="billionaire-brews-container" data-testid="billionaire-brews-container">
        {windowSize > 1024 ? (
          <div className="image-container">
            <img src={BillionaireBrews} alt="Billionaire Brews" />
          </div>
        ) : (
          <div className="image-container">
            <img src={BillionaireBrewsMobileScreen} alt="Billionaire Brews" />
          </div>
        )}
      </div>
    </>
  )
}

export default BillionaireBrew
